import {
  DOCUMENT_VERIFY_DATA,
  DOCUMENT_VERIFY_DATA_CLEAN
} from "../../constants/ActionTypes"

export const INIT_STATE = {
  LIST: [],
  LIST_OFFSET: 0,
  LIST_QUANTITY: 20
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DOCUMENT_VERIFY_DATA: {
      return {
        ...state,
        LIST: removeDuplicates(state.LIST.concat(action.payload)),
        LIST_OFFSET: action.offset ? action.offset : state.LIST_OFFSET
      }
    }

    case DOCUMENT_VERIFY_DATA_CLEAN: {
      return {
        ...state,
        LIST: []
      }
    }
    default:
      return state
  }
}

const by = (property) =>
  function (object) {
    const value = object[property]
    return !(this.has(value) || !this.add(value))
  }

function removeDuplicates(json) {
  return json.filter(by("id_document_verify"), new Set())
}
